import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import moment from 'moment';

class CustomInfoView extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.task.fetchTaskSystemTags());
  }

  _getCustomFieldDescriptions = (customFieldGroup, customFields) => {
    const customFieldDescriptions = customFieldGroup.custom_field_descriptions || [];
    const archived = customFields.filter(item => Utils.Helper.isNullOrUndefined(
      customFieldDescriptions.find(field => field.id === item.custom_field_description.id),
    )).map(item => item.custom_field_description);

    return customFieldDescriptions.concat(archived);
  }

  _renderCustomFields(customFieldGroup, customFields) {
    const { strings, data, tags } = this.props;
    const customFieldDescriptions = this._getCustomFieldDescriptions(customFieldGroup,
      customFields);
    return customFieldDescriptions.map((field) => {
      const customField = customFields.find(item => field.id === item.custom_field_description.id)
        || {};
      let value = customField.value;
      const subvalue = customField.subvalue;

      if (Utils.Helper.isNullOrUndefined(value)) {
        value = strings.noContent;
      } else {
        const option = !Utils.Helper.isNullOrUndefined(customField.custom_field_description.options)
          ? customField.custom_field_description.options.find(item => item.value === value) : null;
        switch (field.field_type) {
          case 'time':
            value = Utils.Formatter.formatTime(value);
            break;
          case 'date':
            value = moment(value).format('DD MMM YYYY');
            break;
          case 'numeric_dropdown':
            value = `${subvalue || option.text} (${value})`;
            break;
          case 'checkbox':
            value = JSON.parse(value).join(', ');
            break;
          default:
            break;
        }
      }
      if (field.field_type === 'rubric' && !Utils.Helper.isNullOrUndefined(field.formula)) {
        value = Utils.RubricCustomFieldParser.parseRubric(field, data, Utils.TaskMergeTags, tags);
      }

      return (
        <Components.Form.Block>
          <Components.Form.Block fontColor="GREY" fontWeight="REGULAR" level={2}>
            {field.name}
          </Components.Form.Block>
          <Components.Form.Block
            className="vf-task__view-form__custom-field__value"
            fontColor="TEXT"
            fontWeight="REGULAR"
            level={3}
          >
            {value}
          </Components.Form.Block>
          {
            field.field_type === 'search_list' && value !== strings.noContent
              && !Utils.Helper.isNullOrUndefined(subvalue) ? (
                <Components.Form.Block fontColor="GREY" fontWeight="REGULAR" level={3}>
                  {field.subname}
                  <Components.Form.Block fontColor="TEXT" fontWeight="REGULAR" level={1}>
                    {subvalue}
                  </Components.Form.Block>
                </Components.Form.Block>
              ) : null
          }
        </Components.Form.Block>
      );
    });
  }

  render() {
    const {
      customFieldGroup, customFields, id, strings,
    } = this.props;
    return (
      <Components.Form.ExpandableContainer
        id={id}
        parent={(
          <Components.Form.Block level={1}>{strings.title}</Components.Form.Block>
        )}
        showByDefault
      >
        {
          Utils.Helper.isNullOrUndefined(customFieldGroup) ? false
            : (
              <Components.Form.Block fontColor="BLUE" iconClassName="versa-customfields" level={2}>
                {customFieldGroup.name}
                <Components.Form.Divider size="SMALL" />
              </Components.Form.Block>
            )
        }
        {
          Utils.Helper.isNullOrUndefined(customFieldGroup) ? false
            : this._renderCustomFields(customFieldGroup, customFields)
        }
      </Components.Form.ExpandableContainer>
    );
  }
}

CustomInfoView.propTypes = {
  customFieldGroup: PropTypes.shape(),
  customFields: PropTypes.arrayOf(PropTypes.shape()),
  data: PropTypes.shape(),
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string,
  strings: PropTypes.shape(),
  tags: PropTypes.shape(),
};

CustomInfoView.defaultProps = {
  customFieldGroup: null,
  customFields: [],
  data: {},
  id: null,
  strings: {},
  tags: {},
};

CustomInfoView.displayName = 'Custom Info View';

function mapStateToProps(state) {
  const { task } = state;
  return {
    tags: task.systemTags,
  };
}

export default connect(mapStateToProps)(CustomInfoView);
